import React from 'react';
import { Typography, Container, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout'; // adjust if needed

const AdminDashboardPage = () => {
  const navigate = useNavigate();

  const handleViewPlayers = () => {
    navigate('/admin/players');
  };

  return (
    <AdminLayout>
      <Container maxWidth="md">
        <Box sx={{ mt: 8 }}>
          <Typography variant="h4" gutterBottom>
            Admin Dashboard
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Welcome to the Admin Dashboard. 
            You can manage workouts, players, and view performance summaries here.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleViewPlayers}
          >
            View Players  
          </Button>  
        </Box>
      </Container>
    </AdminLayout>
  );
};

export default AdminDashboardPage;

